var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{on:{"click":function($event){return _vm.handleClick()}}},[_c('i',{staticClass:"iconfont icon-to-human hover-theme-color"})])])}
var staticRenderFns = []

export { render, staticRenderFns }